import React from 'react';
import NavBarBottom from './NavBarBottom/NavBarBottom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle, faPlus, faTag, faBell, faPhone, faCommentDots } from '@fortawesome/free-solid-svg-icons';

function FeaturesSidebar() {
  return (
    <div className="w-full max-w-xs mx-auto bg-white rounded-2xl shadow-xl p-2 flex flex-col min-h-screen">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-500 to-purple-500 rounded-xl p-4 flex items-center justify-between mb-4">
        <div>
          <div className="text-white font-bold text-lg">KORA</div>
          <div className="text-white text-xs opacity-80">Bienvenue Bernard</div>
        </div>
        <div className="w-8 h-8 bg-white bg-opacity-30 rounded-full flex items-center justify-center">
          <FontAwesomeIcon icon={faUserCircle} className="text-white text-2xl" />
        </div>
      </div>
      {/* Recherche */}
      <div className="mb-4">
        <input type="text" placeholder="Rechercher une relation..." className="w-full rounded-lg border border-gray-200 px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-300" />
      </div>
      {/* Boutons */}
      <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-lg mb-3 flex items-center justify-center gap-2 transition">
        <FontAwesomeIcon icon={faPlus} className="text-lg" /> Ajouter une relation
      </button>
      <button className="w-full bg-purple-500 hover:bg-purple-600 text-white font-semibold py-3 rounded-lg mb-4 flex items-center justify-center gap-2 transition">
        <FontAwesomeIcon icon={faTag} className="text-lg" /> Créer un tag
      </button>
      {/* À relancer */}
      <div className="bg-white border border-gray-200 rounded-xl p-4 mb-4">
        <div className="flex items-center gap-2 mb-3">
          <FontAwesomeIcon icon={faBell} className="text-yellow-500" />
          <span className="font-semibold text-gray-700 text-sm">À relancer :</span>
        </div>
        <div className="flex items-center gap-2 mb-2">
          <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center font-bold text-blue-700 text-sm">AL</div>
          <span className="text-gray-800 text-sm">Antoine Laurent</span>
          <span className="ml-auto text-xs bg-gray-100 text-gray-500 rounded px-2">1m</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-purple-100 flex items-center justify-center font-bold text-purple-700 text-sm">CB</div>
          <span className="text-gray-800 text-sm">Charlotte Bernard</span>
          <span className="ml-auto text-xs bg-gray-100 text-gray-500 rounded px-2">2m</span>
        </div>
      </div>
      {/* Suggestions d'actions */}
      <div className="bg-white border border-gray-200 rounded-xl p-4 mb-4">
        <div className="flex items-center gap-2 mb-3">
          <FontAwesomeIcon icon={faBell} className="text-cyan-500" />
          <span className="font-semibold text-gray-700 text-sm">Suggestions d'actions :</span>
        </div>
        <div className="flex items-center gap-2 mb-2 cursor-pointer hover:bg-cyan-50 rounded-lg px-2 py-1 transition">
          <FontAwesomeIcon icon={faPhone} className="text-green-500" />
          <span className="text-gray-800 text-sm">Planifier un appel</span>
        </div>
        <div className="flex items-center gap-2 cursor-pointer hover:bg-cyan-50 rounded-lg px-2 py-1 transition">
          <FontAwesomeIcon icon={faCommentDots} className="text-blue-500" />
          <span className="text-gray-800 text-sm">Envoyer un message</span>
        </div>
      </div>
      {/* Spacer */}
      <div className="flex-1" />
      {/* Navigation bas */}
      <NavBarBottom />
    </div>
  );
}

export default FeaturesSidebar; 